import { render, staticRenderFns } from "./ApiSection.vue?vue&type=template&id=37d7b9d3&"
import script from "./ApiSection.vue?vue&type=script&lang=js&"
export * from "./ApiSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports